import request from "@/config/axios";

const mode = 'basedata'; // 对应config里的oDomains的key
const mode1='idc';

// 数据统计
export function stat(params) {
  return request({
    url: '/v1/report/stat',
    method: 'get',
    mode,
    params
  })
}
// 跳绳详情
export function getSkipStatList(params) {
  return request({
    url: '/v1/report/getSkipStatList',
    method: 'get',
    mode,
    params
  })
}
// 打卡详情
export function getBeaconInfoList(data) {
  return request({
    url: '/v1/report/getBeaconInfoList',
    method: 'post',
    mode,
    data
  })
}

// 教师端:获取报告数据
export function getReport(params) {
  return request({
    url: '/v1/report/techer/getReport',
    method: 'get',
    mode,
    params
  })
}
// 教师端:获取学生的实践打卡报告
export function getStudentBeaconReport(params) {
  return request({
    url: '/v1/report/techer/getStudentBeaconReport',
    method: 'get',
    mode,
    params
  })
}
// 教师端:获取班级的跳绳报告
export function getClassSkipReport(params) {
  return request({
    url: '/v1/report/techer/getClassSkipReport',
    method: 'get',
    mode,
    params
  })
}
// 教师端:获取班级内学生的实践打卡报告
export function getStudentBeaconReportList(params) {
  return request({
    url: '/v1/report/techer/getStudentBeaconReportList',
    method: 'get',
    mode,
    params
  })
}
// 教师端:获取班级内学生的跳绳报告
export function getStudentSkipReport(params) {
  return request({
    url: '/v1/report/techer/getStudentSkipReport',
    method: 'get',
    mode,
    params
  })
}
// 获取学生跳绳数据
export function getSkipInfo(params) {
  return request({
    url: '/v1/kykData/getSkipInfo',
    method: 'get',
    mode,
    params
  })
}
// 分页获取学生跳绳信息
export function pageListSkipByCondition(data) {
  return request({
    url: '/v1/kykData/pageListSkipByCondition',
    method: 'post',
    mode,
    data
  })
}
// 12.1.家长端 - 分页获取课堂互动请求接口
export function statOfParentPaged(data) {
  return request({
    url: '/v1/classInteraction/statOfParentPaged',
    method: 'post',
    mode:mode1,
    data
  })
}
// 12.1.老师端 - 分页获取课堂互动请求接口
export function statOfTeacherPaged(data) {
  return request({
    url: '/v1/classInteraction/statOfTeacherPaged',
    method: 'post',
    mode:mode1,
    data
  })
}
// 12.1.老师端 - 获取课堂互动学生答题统计口
export function studentStatOfTeacherList(data) {
  return request({
    url: '/v1/classInteraction/studentStatOfTeacherList',
    method: 'post',
    mode:mode1,
    data
  })
}


// 显示手环报告数据
export function braceletReport(params) {
  return request({
    url: '/v1/smartBand/getReport',
    method: 'get',
    mode:mode1,
    params
  })
}

// 按类型获取步数报告详情信息
export function getStepDataDetail(params) {
  return request({
    url: '/v1/report/getStepByType',
    method: 'get',
    mode,
    params
  })
}
// 获取学生步数详情
export function getStudentStepDetail(params) {
  return request({
    url: '/v1/report/getStepInfo',
    method: 'get',
    mode,
    params
  })
}
// 设置获取学生目标步数
export function setStudentStep(data) {
  return request({
    url: '/v1/student/setTargetStep',
    method: 'post',
    mode,
    data
  })
}

// 跳绳统计
export function getBestSkipReport(data) {
  return request({
    url: '/v1/schoolOpsInfo/getBestSkipReport',
    method: 'post',
    mode,
    data
  })
}